const locale = {
  CAPTURE: 'Connect',
  APPLICATIONS: 'Applications'
};

export default locale;
